<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
				<el-col :span="4">
					<!--기준일-->
					<sf-group-wrapper :label="getMessage_('QWCC001170')">
						<el-date-picker v-model="searchParams.stdDt" type="date" format="yyyy-MM-dd" value-format="yyyyMMdd" />
					</sf-group-wrapper>
				</el-col>
				<el-col :span="6">
					<!--품번 -->
					<sf-input-group
						:label="getMessage_('QWCC000956')"
						:inputValue="searchParams.partNo"
						:onChange="value => setSearchParam_({ key: 'partNo', value })"
					/>
				</el-col>
			</el-row>
			<template slot="button">
				<sf-button line icon="search" :onClick="search" v-if="isButton_(scrId, 'CR')">
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</template>
		</sf-search-layout>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@qms/comm/commpopup/AsPartPopup/store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' },
		partNum: { type: String, default: '' }
	},
	async created() {
		await this.search();
	},
	data() {
		return {};
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		search() {
			if (this.searchParams.stdDt) {
				this.$sf_toggleLoading(true);
				this.getPopupParts_()
					.catch(error => {
						this.$sf_toast({
							type: 'error',
							message: error.message
						});
					})
					.finally(() => {
						this.$sf_toggleLoading(false);
					});
			} else {
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('SWCC000008'),
					message: this.getMessage_('QWCC001682')
				}); //필수 검색 값을 확인해주십시오
			}
		},
		setSearchParam({ key, value }) {
			this.searchParams[key] = value;
		}
	}
};
</script>

<style></style>
